export const getFileExtension = (fileName?: string | null): string | null => {
  const isValidUrl = !!fileName?.split('.')?.length;
  const fileFormat = isValidUrl ? fileName.split('.').pop()! : null;

  return fileFormat;
};
